import React from 'react';
import LocalizedLink from 'components/LocalizedLink';
import MedalEmptyIcon from 'components/icons/MedalEmptyIcon';
import OfferIcon from 'components/icons/OfferIcon';
import AgendaIcon from 'components/icons/CalendarIcon';
import SearchIcon from 'components/icons/SearchIcon';
import { Translator } from 'Translator';
import { useLocation } from 'react-router-dom';
import FinanceIcon from 'components/icons/FinanceIcon';
import ExternalLink from "components/organisms/ExternalLink";
import {UrlHelper} from "hoc/UrlHelper";
import { useUser } from '~/authentication/store';
import HomeIcon from "components/icons/HomeIcon";

const CSS = require('./NavbarList.less');

interface ListItemOuterProps {
  onClick: () => void;
}

function HostListItem({ onClick }: ListItemOuterProps) {
  const { isHost } = useUser();
  if (isHost) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <ExternalLink elementType={'a'} className={CSS.MenuItemLink} url={UrlHelper.url('/become-a-host/', false)} openInNewTab={true}>
        {Translator.translate('Navbar.Buttons.becomeAHost', {}, true, 'Become a host')}
      </ExternalLink>
      <div className={CSS.IconContainer}>
        <MedalEmptyIcon className={CSS.Icon} width={13} height={27}/>
      </div>
    </li>
  );
}

function OffersListItem({ onClick }: ListItemOuterProps) {
  const { isHost } = useUser();
  if (!isHost) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to={'/host/experiences/'}>
        {Translator.translate('Navbar.Buttons.myOffers', {}, true, 'My offers')}
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <OfferIcon className={CSS.Icon} width={19} height={24} />
      </div>
    </li>
  );
}

function AgendaListItem({ onClick }: ListItemOuterProps) {
  const { isHost } = useUser();
  
  if (!isHost) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to={'/host-agenda/'}>
        {Translator.translate('Navbar.Buttons.myAgenda', {}, true, 'My agenda')}
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <AgendaIcon className={CSS.Icon} width={20} height={24}/>
      </div>
    </li>
  );
}

function ExploreListItem({ onClick, isCandidate }: ListItemOuterProps & { isCandidate: boolean }) {
  const location = useLocation();
  const { isHost } = useUser();
  if (!isCandidate && !isHost) {
    return null;
  }

  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to={{ ...location, pathname: '/', search: `?noHostRedirect` }}>
        {Translator.translate('Navbar.Buttons.Explore', {}, true, 'Explore as guest')}
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <SearchIcon className={CSS.Icon} width={22} height={22}/>
      </div>
    </li>
  );
}

function FinanceInfoListItem({ onClick }: ListItemOuterProps) {
  const { isHost } = useUser();

  if (!isHost) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <ExternalLink className={CSS.MenuItemLink} url={`${URL_HOST_FINANCES_HOST}/host/finance/`} openInNewTab={false}>
        Finance information
      </ExternalLink>
      <div className={CSS.IconContainer}>
        <FinanceIcon className={CSS.Icon} width={24} height={24}/>
      </div>
    </li>
  );
}

function DashboardListItem({ onClick }) {
  const { isHost } = useUser();

  if (!isHost) {
    return null;
  }
  return (
    <li className={CSS.MenuItem} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemButton} to={'/host/home/'}>
        Dashboard
      </LocalizedLink>
      <div className={CSS.IconContainer}>
        <HomeIcon className={CSS.Icon}/>
      </div>
    </li>
  );
}

export {
  HostListItem,
  OffersListItem,
  AgendaListItem,
  ExploreListItem,
  FinanceInfoListItem,
  DashboardListItem
};
